import { render } from "./MobilityCard.vue?vue&type=template&id=2125262d&scoped=true"
import script from "./MobilityCard.vue?vue&type=script&lang=js"
export * from "./MobilityCard.vue?vue&type=script&lang=js"

import "./MobilityCard.vue?vue&type=style&index=0&id=2125262d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2125262d"]])

export default __exports__